module.exports = __webpack_public_path__ + "static/fonts/PlusJakartaDisplay-Light.07f58e29.woff2";